import {
  buttonClasses,
  Components,
  svgIconClasses,
  Theme,
} from '@mui/material';
import {
  Error, Focused, Disabled, Primary, Secondary,
} from '../color';
import { CornerLarge } from '../corners';
import getTransition from '../utilities/getTransition';
import { iconButtonClasses } from './types';
import { Spacing2 } from '../spacing';
import { Input } from '../sizes';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  defaultProps: {
    size: 'medium',
    color: 'secondary',
  },
  styleOverrides: {
    root: {
      ...CornerLarge,
      ...getTransition(['outline-color', 'background-color', 'color']),
      boxSizing: 'border-box',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      width: Input.medium,
      height: Input.medium,
      [`.${svgIconClasses.root}`]: {
        width: 20,
        height: 20,
      },
      [`&.${buttonClasses.focusVisible}`]: {
        outlineColor: Focused.main,
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineOffset: 1,
      },

      [`&.${buttonClasses.disabled}`]: {
        color: Disabled.default.text,
        [`&.${iconButtonClasses.variantContained}`]: {
          color: Disabled.default.text,
          backgroundColor: Disabled.default.main,
        },
      },
    },
    colorPrimary: {
      ':hover': {
        backgroundColor: Primary.surface.hover,
      },
      ':active': {
        backgroundColor: Primary.surface.pressed,
      },
      [`&.${iconButtonClasses.selected}`]: {
        backgroundColor: Primary.surface.active,
        ':active': {
          backgroundColor: Primary.surface.pressed,
        },
      },

      [`&.${iconButtonClasses.variantContained}`]: {
        backgroundColor: Primary.default.main,
        color: Primary.default.text,

        ':hover': {
          backgroundColor: Primary.default.hover,
        },
        ':active': {
          backgroundColor: Primary.default.pressed,
        },
        [`&.${iconButtonClasses.selected}`]: {
          backgroundColor: Primary.default.active,
          ':active': {
            backgroundColor: Primary.default.pressed,
          },
        },
      },
    },
    colorSecondary: {
      ':hover': {
        backgroundColor: Secondary.surface.hover,
      },
      ':active': {
        backgroundColor: Secondary.surface.pressed,
      },
      [`&.${iconButtonClasses.selected}`]: {
        backgroundColor: Secondary.surface.active,
        ':active': {
          backgroundColor: Secondary.surface.pressed,
        },
      },

      [`&.${iconButtonClasses.variantContained}`]: {
        backgroundColor: Secondary.container.main,
        color: Secondary.container.text,

        ':hover': {
          backgroundColor: Secondary.container.hover,
        },
        ':active': {
          backgroundColor: Secondary.container.pressed,
        },
        [`&.${iconButtonClasses.selected}`]: {
          backgroundColor: Secondary.container.active,
          ':active': {
            backgroundColor: Secondary.container.pressed,
          },
        },
      },
    },
    colorError: {
      ':hover': {
        backgroundColor: Error.surface.hover,
      },
      ':active': {
        backgroundColor: Error.surface.pressed,
      },
      [`&.${iconButtonClasses.selected}`]: {
        backgroundColor: Error.surface.active,
        ':active': {
          backgroundColor: Error.surface.pressed,
        },
      },

      [`&.${iconButtonClasses.variantContained}`]: {
        // NOTE: no variant strong defined in Figma
      },
    },
    sizeExtraSmall: {
      width: Input.extraSmall,
      height: Input.extraSmall,
      padding: Spacing2,
      // NOTE: known non-standard radius
      borderRadius: 6,
      [`.${svgIconClasses.root}`]: {
        width: 16,
        height: 16,
      },
    },
    sizeSmall: {
      width: Input.small,
      height: Input.small,
    },
    sizeLarge: {
      width: Input.large,
      height: Input.large,
      [`.${svgIconClasses.root}`]: {
        width: 24,
        height: 24,
      },
    },
  },
};
